import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OCC_ENDPOINTS } from '@city/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { CityService } from '../services/city.service';

@Injectable({ providedIn: 'root' })
export class BaseStoreInterceptor implements HttpInterceptor {
  activeBaseStore: string;

  constructor(
    private cityService: CityService,
    private occEndpointsService: OccEndpointsService,
  ) {
    this.cityService.activeBaseStoreCode$.subscribe((data: string) => (this.activeBaseStore = data));
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      request.url.includes(this.occEndpointsService.getBaseUrl({ prefix: false, baseSite: false })) &&
      request.url.split('?')[0] !== this.occEndpointsService.buildUrl(OCC_ENDPOINTS.baseStores)
    ) {
      return this.cityService.activeBaseStoreCode$.pipe(
        take(1),
        switchMap((activeBaseStore: string) => {
          // Тут у нас появляестя возможность проставить в запрос бэйсстор, отличный от текущего.
          // Пользоваться с особой осторожностью
          const cartBaseStore = request.params.get('baseStore');
          request = cartBaseStore
            ? request
            : request.clone({
                setParams: {
                  baseStore: activeBaseStore,
                },
              });

          return next.handle(request);
        }),
      );
    }

    return next.handle(request);
  }
}
